<template>
  <div class="grid grid-cols-1 bg-white rounded-lg border border-gray-400 my-2 p-4 dark:bg-slate-900 dark:border-gray-700">
    <div class="text-blue-600 col-span-12 font-bold border-b">
      Gráficos
    </div>
    <SimpleSkeleton
      v-if="isLoading"
      class="p-5"
      :options="skeletonGraficas" />
    <div v-else-if="graficas.length > 0">
      <div v-for="graf in graficas" :key="graf.titulo">
        <div class=" text-2xl p-4"> {{ graf.titulo }}</div>
        <canvas :id="graf.options.id" width="800" height="400"></canvas>
      </div>
    </div>
    <div v-else>
        No encontramos graficas disponibles para este paciente.
    </div>
  </div>
</template>
<!-- eslint-disable @typescript-eslint/no-explicit-any -->
<script setup lang="ts">
import { ref, onMounted, nextTick } from 'vue'
import type { ICitaTechnologiasSalud, IGraficaItem } from '@/modules/Asistencial/interfaces'
import type { IConfPersonasPaciente } from '@/modules/Administracion/interfaces'
import { Chart } from 'chart.js/auto'
import zoomPlugin from 'chartjs-plugin-zoom'
import { useGraficas } from '@/modules/Asistencial/composables/useGraficas'
import type { IComponentGraficasItems } from '@/modules/Configuracion/interfaces/IFormComponent'

Chart.register(zoomPlugin)

const props = defineProps<{
  persona: IConfPersonasPaciente
  technologias?: ICitaTechnologiasSalud[]
  graficasList?: IComponentGraficasItems[]
}>()
const { persona, technologias, graficasList = null } = props
const isLoading = ref(true)
const graficas = ref<IGraficaItem[]>([])
const skeletonGraficas = {
  filas: [
    {
      class:'items-end',
      cols: Array.from({ length: 20 }, () => {
        const randomHeight = Math.floor(Math.random() * (400 - 100 + 1)) + 100;
        return {
          style: 'width:3%;margin-left:10px',
          lines: [
            { noRounded: true, style: `width:100%; height: ${randomHeight}px` }
          ]
        }
      })
    }
  ]
}
onMounted(async () => {
  isLoading.value = true
  const { getGraficas, dibujarGraficas } = useGraficas(persona, technologias, graficasList)
  const { validate, validateMessage, data } = await getGraficas()
  if (validate) {
    graficas.value = data
    isLoading.value = false
    await nextTick()
    dibujarGraficas(graficas.value)
  } else {
    isLoading.value = false
    window.notificacion.report('warning', 'Problemas en graficas!', validateMessage)
  }
})
</script>
